module.exports = __webpack_public_path__ + "img/01.5096d7b7.jpg";